"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSingletonGetter = exports.singletonGetter = exports.defaultGetter = void 0;
const lookup_1 = require("../../common/globals/lookup");
const defaultGetter = InstanceConstructor => {
  let instance;
  const getter = () => {
    return instance !== null && instance !== void 0 ? instance : instance = new InstanceConstructor();
  };
  return getter;
};
exports.defaultGetter = defaultGetter;
const getFaireNamespace = () => {
  // We call getGlobalLookup and skip local storage to avoid a circular dependency on
  // singletonGetter -> getGlobalProperty -> Storage -> singletonGetter
  return (0, lookup_1.getGlobalLookup)()("faire");
};
const singletonGetter = (InstanceConstructor, params) => {
  var _a, _b;
  let instance;
  if (params === null || params === void 0 ? void 0 : params.globalSingleton) {
    return () => instance !== null && instance !== void 0 ? instance : instance = new InstanceConstructor();
  }
  const faire = getFaireNamespace();
  const getter = (_b = (_a = faire === null || faire === void 0 ? void 0 : faire.singletons) === null || _a === void 0 ? void 0 : _a.getter) !== null && _b !== void 0 ? _b : exports.defaultGetter;
  return getter(InstanceConstructor, params);
};
exports.singletonGetter = singletonGetter;
/**
 * Sets the global singleton getter, i.e. global.faire["singletons"]["getter"].
 * The request handler is later resolved via getGlobalProperty("faire.singletons.getter"),
 * so in a Zone context (i.e. SSR), this should be done using Zone.fork, setting "faire.singletons.getter".
 */
const setSingletonGetter = getter => {
  const faire = getFaireNamespace();
  if (!faire) {
    throw new Error("Faire namespace not found");
  }
  const singletons = faire.singletons || (faire.singletons = {});
  singletons.getter = getter;
};
exports.setSingletonGetter = setSingletonGetter;